<template>
  <div class='h-dialogContainer'>
    <div class='row h-row-inputBox'>
      <div class='col-sm-6 h-col-inputBox'>
        <div class='h-inputLit'>{{this.$t('Alarm.alarmID')}}:</div>
        <ejs-textbox :readonly='true' :value='alarmData.alarmID'></ejs-textbox>
      </div>
      <div class='col-sm-6 h-col-inputBox'>
        <div class='h-inputLit'>{{this.$t('Alarm.alarmLevel')}}:</div>
        <ejs-textbox :readonly='true' :value='alarmData.level'></ejs-textbox>
      </div>
      <div class='col-sm-6 h-col-inputBox'>
        <div class='h-inputLit'>{{this.$t('Alarm.alarmType')}}:</div>
        <ejs-textbox :readonly='true' :value='alarmData.eventType'></ejs-textbox>
      </div>
      <div class='col-sm-6 h-col-inputBox'>
        <div class='h-inputLit'>{{this.$t('Alarm.neName')}}:</div>
        <ejs-textbox :readonly='true' :value='alarmData.neName'></ejs-textbox>
      </div>
      <div class='col-sm-6 h-col-inputBox'>
        <div class='h-inputLit'>{{this.$t('Alarm.neType')}}:</div>
        <ejs-textbox :readonly='true' :value='alarmData.neType'></ejs-textbox>
      </div>
      <div class='col-sm-6 h-col-inputBox'>
        <div class='h-inputLit'>{{this.$t('Alarm.brdType')}}:</div>
        <ejs-textbox :readonly='true' :value='alarmData.brdType'></ejs-textbox>
      </div>
      <div class='col-sm-6 h-col-inputBox'>
        <div class='h-inputLit'>{{this.$t('Alarm.clearState')}}:</div>
        <ejs-textbox :readonly='true' :value='alarmData.clearState'></ejs-textbox>
      </div>
      <div class='col-sm-6 h-col-inputBox'>
        <div class='h-inputLit'>{{this.$t('Alarm.confirmState')}}:</div>
        <ejs-textbox :readonly='true' :value='alarmData.confirmState'></ejs-textbox>
      </div>
      <div class='col-sm-6 h-col-inputBox'>
        <div class='h-inputLit'>{{this.$t('Alarm.alarmSource')}}:</div>
        <ejs-textbox :readonly='true' :value='alarmData.frameslot'></ejs-textbox>
      </div>
      <div class='col-sm-6 h-col-inputBox'>
        <div class='h-inputLit'>{{this.$t('Alarm.createTime')}}:</div>
        <ejs-datepicker :format='dateFormat' :readonly='true' :value='alarmData.createTime'></ejs-datepicker>
      </div>
      <div class='col-sm-6 h-col-inputBox'>
        <div class='h-inputLit'>{{this.$t('Alarm.clearTime')}}:</div>
        <ejs-datepicker :format='dateFormat' :readonly='true' :value='alarmData.clearTime'></ejs-datepicker>
      </div>
      <div class='col-sm-6 h-col-inputBox'>
        <div class='h-inputLit'>{{this.$t('Alarm.confirmTime')}}:</div>
        <ejs-datepicker :format='dateFormat' :readonly='true' :value='alarmData.confirmTime'></ejs-datepicker>
      </div>
      <div class='col-sm-6 h-col-inputBox'>
        <div class='h-inputLit'>{{this.$t('Alarm.clearUser')}}:</div>
        <ejs-textbox :readonly='true' :value='alarmData.clearUser'></ejs-textbox>
      </div>
      <div class='col-sm-6 h-col-inputBox'>
        <div class='h-inputLit'>{{this.$t('Alarm.confirmUser')}}:</div>
        <ejs-textbox :readonly='true' :value='alarmData.confirmUser'></ejs-textbox>
      </div>
      <div class='col-sm-6 h-col-inputBox'>
        <div class='h-inputLit'>{{this.$t('Alarm.alarmName')}}:</div>
        <ejs-textbox multiline='true' :readonly='true' :value='alarmData.alarmName'></ejs-textbox>
      </div>
      <div class='col-sm-6 h-col-inputBox'>
        <div class='h-inputLit'>{{this.$t('Alarm.extraInfo')}}:</div>
        <ejs-textbox multiline='true' :readonly='true' :value='alarmData.appendInfo'></ejs-textbox>
      </div>
      <div class='col-sm-6 h-col-inputBox'>
        <div class='h-inputLit'>{{this.$t('Alarm.xxdwinfo1')}}:</div>
        <ejs-textbox multiline='true' :readonly='true' :value='alarmData.xxdwinfo1'></ejs-textbox>
      </div>
      <div class='col-sm-6 h-col-inputBox'>
        <div class='h-inputLit'>{{this.$t('Alarm.xxdwinfo2')}}:</div>
        <ejs-textbox multiline='true' :readonly='true' :value='alarmData.xxdwinfo2'></ejs-textbox>
      </div>
      <div class='col-sm-6 h-col-inputBox'>
        <div class='h-inputLit'>{{this.$t('Alarm.xxkzinfo1')}}:</div>
        <ejs-textbox multiline='true' :readonly='true' :value='alarmData.xxkzinfo1'></ejs-textbox>
      </div>
      <div class='col-sm-6 h-col-inputBox'>
        <div class='h-inputLit'>{{this.$t('Alarm.xxkzinfo2')}}:</div>
        <ejs-textbox multiline='true' :readonly='true' :value='alarmData.xxkzinfo2'></ejs-textbox>
      </div>
      <div class='col-sm-6 h-col-inputBox'>
        <div class='h-inputLit'>{{this.$t('Alarm.xxkzinfo3')}}:</div>
        <ejs-textbox multiline='true' :readonly='true' :value='alarmData.xxkzinfo3'></ejs-textbox>
      </div>
      <div class='col-sm-6 h-col-inputBox'>
        <div class='h-inputLit'>{{this.$t('Alarm.xxkzinfo4')}}:</div>
        <ejs-textbox multiline='true' :readonly='true' :value='alarmData.xxkzinfo4'></ejs-textbox>
      </div>
      <div class='col-sm-6 h-col-inputBox'>
        <div class='h-inputLit'>{{this.$t('Alarm.cause')}}:</div>
        <ejs-textbox multiline='true' :readonly='true' :value='alarmData.cause'></ejs-textbox>
      </div>
      <div class='col-sm-6 h-col-inputBox'>
        <div class='h-inputLit'>{{this.$t('Alarm.advise')}}:</div>
        <ejs-textbox multiline='true' :readonly='true' :value='alarmData.solution'></ejs-textbox>
      </div>
      <div class='col-sm-6 h-col-inputBox'>
        <div class='h-inputLit'>{{this.$t('Alarm.remark')}}:</div>
        <ejs-textbox multiline='true' :readonly='true' :value='alarmData.addtionalinfo'></ejs-textbox>
      </div>
    </div>
    <div class='h-clear-rowMg'></div>
  </div>
</template>
<script>
export default {
  name: 'alarmDetail',
  data() {
    return {
      dateFormat: 'yyyy-MM-dd HH:mm:ss',
      alarmData: {}
    };
  },
  methods: {
    setAlarmId(msg) {
      const This = this;
      This.alarmData = {
        alarmID: msg.alarmID,
        level: this.levelFormat(msg.level),
        eventType: this.typeFormat(msg.alarmType),
        neName: msg.neName,
        neType: msg.neTypeStr,
        brdType: msg.brdTypeStr,
        frameslot: msg.neAlarmFDN,
        clearState: this.clearFormat(msg.clearState),
        confirmState: this.confirmFormat(msg.confirmState),
        createTime: msg.createTimeFormat,
        clearTime: msg.clearTimeFormat,
        confirmTime: msg.confirmTimeFormat,
        clearUser: msg.clearUsrName,
        confirmUser: msg.confirmUsrName,
        alarmName: msg.alarmName,
        appendInfo: msg.appendInfo,
        xxdwinfo1: msg.xxdwinfo1,
        xxdwinfo2: msg.xxdwinfo2,
        xxkzinfo1: msg.xxkzinfo1,
        xxkzinfo2: msg.xxkzinfo2,
        xxkzinfo3: msg.xxkzinfo3,
        xxkzinfo4: msg.xxkzinfo4,
        cause: msg.cause,
        solution: msg.advise,
        addtionalinfo: msg.comment
      };
    },
    levelFormat(data) {
      return this.$t(`Alarm.alarmLevel_${data}`);
    },
    typeFormat(data) {
      return this.$t(`Alarm.alarmType_${data}`);
    },
    clearFormat(data) {
      return this.$t(`Alarm.alarmClearStatus_${data}`);
    },
    confirmFormat(data) {
      return this.$t(`Alarm.alarmConfirmStatus_${data}`);
    }
  }
};
</script>